import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'

const Styles = require('./TargetDateSeriesPartnerLogos.css')

@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateSeriesPartnerLogos extends Component {
  static propTypes = {
    // three letters, fff/dff/gef/gff/pff/wff/tff
    iyvCode: PropTypes.string.isRequired,
  }
  constructor(props) {
    super(props)
  }

  render() {
    const { iyvCode } = this.props

    let partnerLogos = null
    let partnerTagline = null
    switch (iyvCode) {
      case 'fff':
        partnerLogos = [
          [
            require('../../../static/images/partnerlogos/FFIS.png'),
            'FFF Solutions'
          ],
          [
            require(
              '../../../static/images/partnerlogos/macroclimate_logo_wide.png'
            ),
            'Macroclimate'
          ],
          [
            require('../../../static/images/partnerlogos/urgewald.png'),
            'Urgewald Global Coal Exit List'
          ],
        ]
        partnerTagline = 'Company research provided by'
        break

      case 'ffb':
        partnerLogos = [
          [
            require('../../../static/images/partnerlogos/banking-on-climate-chaos.jpg'),
            'Banking on Climate Chaos coalition',
            1
          ],
        ]
        partnerTagline = 'Company research provided by'
        break

      case 'ffi':
        partnerLogos = [
          [
            require('../../../static/images/partnerlogos/iof-logo.png'),
            'Insure our Future'
          ],
        ]
        partnerTagline = 'Company research provided by'
        break

      case 'dff':
        partnerLogos = [
          [
            require('../../../static/images/partnerlogos/FOE_logo.png'),
            'Friends of the Earth U.S.'
          ],
        ]
        partnerTagline = 'Deforestation Free Funds is a partnership with'
        break

      case 'gef':
        partnerLogos = [
          [
            require('../../../static/images/partnerlogos/equileap-logo.png'),
            'Equileap'
          ],
        ]
        partnerTagline = 'Company research provided by'
        break

      // case 'gff':
      //   break

      case 'pff':
        partnerLogos = [
          [
            require('../../../static/images/partnerlogos/AFSC-logo.jpg'),
            'American Friends Service Committee'
          ],
        ]
        partnerTagline = 'Company research sourced from'
        break

      case 'wff':
        partnerLogos = [
          [
            require('../../../static/images/partnerlogos/SIPRI_small.png'),
            'Stockholm International Peace Research Institute'
          ],
          [
            require(
              '../../../static/images/partnerlogos/PAX_Logo_EN_WithSlogan_WEB_FC.png'
            ),
            'PAX'
          ],
        ]
        partnerTagline = 'Company research sourced from'
        break

      case 'tff':
        partnerLogos = [
          [
            require(
              '../../../static/images/partnerlogos/ucsf-tobacco-logo.png'
            ),
            'UCSF Center for Tobacco Control Research and Education'
          ],
          [
            require(
              '../../../static/images/partnerlogos/ucsf-smokefreemovies-logo.png'
            ),
            'UCSF Smoke Free Movies Campaign'
          ],
        ]
        partnerTagline = 'Company research sourced from'
        break
    }

    if (!partnerLogos || !partnerTagline) { return null }

    //
    return (
      <div styleName='partners-wrap'>
        <div>
          <div>
            {partnerTagline}
          </div>
          {
            partnerLogos.length > 0 ?
              (
                <div styleName='partner-logo-img-flex'>
                  {
                    partnerLogos.map((e, i)=>{
                      return (
                        <img
                          key={'partner-logo-'+i}
                          src={e[0]}
                          alt={e[1]}
                          styleName={e[2] ? 'partner-logo-img-lg' : 'partner-logo-img'}
                        />
                      )
                    })
                  }
                </div>
              ) :
              null
          }
        </div>
      </div>
    )
  }

}